'use strict';//Indicating browser should run only in java script mode
; (function () {

    var AddOrEditNotesRoutes = [

        {
            "name": "AddOrEditNotesPopup",
            "url": "AddOrEditNotesPopup",
            "templateUrl": "AngularScripts/AddOrEditNotes/Htmls/AddOrEditNotesPopup.html",
            "RoutingNumber": 4666,
            files: [
                "AngularScripts/AddOrEditNotes/Services/AddOrEditNotesPopupService.js",
                "AngularScripts/AddOrEditNotes/Controllers/AddOrEditNotesPopupController.js",

            ]
        },

    ];

    angular.module('EMR.AddOrEditNotesModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(AddOrEditNotesRoutes, $stateProvider);
            }]);
})();
